import { DiscographyId, SourceId } from '../useDiscographyIds';

export function generateSpotifyArtistUrl(artistId: string): string {
  return `https://open.spotify.com/artist/${artistId}`;
}

export function generateDiscogsArtistUrl(artistId: string): string {
  return `https://www.discogs.com/artist/${artistId}`;
}

export function generateDeezerArtistUrl(artistId: string): string {
  return `https://www.deezer.com/en/artist/${artistId}`;
}

export function generateMusicbrainzArtistUrl(artistId: string): string {
  return `https://musicbrainz.org/artist/${artistId}`;
}

export function generateArtistUrlBySource(
  artistId: string,
  source: keyof DiscographyId['source_ids']
) {
  switch (source) {
    case 'spotify':
      return generateSpotifyArtistUrl(artistId);
    case 'deezer':
      return generateDeezerArtistUrl(artistId);
    case 'discogs':
      return generateDiscogsArtistUrl(artistId);
    case 'musicbrainz':
      return generateMusicbrainzArtistUrl(artistId);
    default:
      return '';
  }
}

export const artistSourceIdsAreNotValid = (source_ids: SourceId[]) => {
  return source_ids.some((source_id) => !source_id.valid);
};
